<template>
  <div class="addMember">
    <el-dialog
      :title="title"
      :visible.sync="show"
      :modal-append-to-body="false"
      width="700px"
      height="500px"
      style="'margin-top:15vh;'"
      class="welcomeDia treeDia"
      :close-on-click-modal="false"
      @close="closeTree"
    >
      <div class="head-wrap">
        <div class="head-left">
          <el-input
            placeholder="搜索成员或部门"
            suffix-icon="el-icon-search"
            size="mini"
            @input="searchFn"
            @clear="searchFnClear"
            v-model="formInline.usageScenario"
            clearable
            class="search-input"
          ></el-input>
        </div>
        <div class="head-right">
          <span class="selected-title">已选成员</span>
        </div>
      </div>
      <div class="data-wrap">
        <div class="tree-wrap">
          <el-tree
            style="height: 100%"
            v-show="serarchState"
            check-strictly
            :data="treeData"
            @check-change="nodeClick"
            @check="checkHandle"
            node-key="id"
            show-checkbox
            :default-expanded-keys="defaultShowNodes"
            :default-checked-keys="defaultCheckedKeys"
            :expand-on-click-node="false"
            :current-node-key="currentNodeKey"
            ref="codeTree"
            :highlight-current="true"
            :check-on-click-node="true"
            :props="defaultProps"
            class="tree filter-tree"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span
                :title="data.hasChildren ? data.departmentName : data.userName"
                >&nbsp;&nbsp;{{
                  data.hasChildren ? data.departmentName : data.userName
                }}</span
              >
            </span>
          </el-tree>
          <div class="ww_searchResult" v-show="!serarchState">
            <div class="search-title" v-if="searchStaff.length !== 0">人员</div>
            <ul class="search-data-wrap">
              <li
                v-for="(item, index) in searchStaff"
                :key="index"
                :style="index == 0 ? 'background:#0C4C7F' : ''"
                @click="clickSearchSelect(index, item)"
              >
                <a
                  href="javascript:;"
                  class="ww_searchResult_itemTxt"
                  :style="index == 0 ? 'color:#FFF' : ''"
                >
                  <span
                    class="ww_searchResult_title_peopleName"
                    :title="item.userName"
                    >{{ item.userName }}</span
                  >
                  <span
                    class="ww_searchResult_title_peopleDepartment"
                    :title="item.departmentName"
                    >{{ item.departmentName }}</span
                  >
                </a>
              </li>
            </ul>
            <div class="search-title" v-if="searchDepart.length !== 0">
              部门
            </div>
            <ul class="search-data-wrap">
              <li
                v-for="(item, index) in searchDepart"
                :key="index"
                :style="
                  searchStaff.length === 0 && index == 0
                    ? 'background:#0C4C7F'
                    : ''
                "
                @click="clickSearchSelect(index, item)"
              >
                <a
                  href="javascript:;"
                  class="ww_searchResult_itemTxt"
                  :style="
                    searchStaff.length === 0 && index == 0 ? 'color:#FFF' : ''
                  "
                >
                  <span class="ww_searchResult_title_peopleName">{{
                    item.departmentName
                  }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="selected-wrap" id="selectedWrap">
          <div
            v-for="(item, index) in currentIdName"
            :key="index"
            class="select-right"
          >
            <i
              :class="
                item.type == 'depart' ? 'el-icon-folder-opened' : 'el-icon-user'
              "
              >&nbsp;{{ item.name }}</i
            >
            <i class="el-icon-close" @click="clickCurrrntFn(item)"></i>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeTree">取 消</el-button>
        <el-button type="primary" size="small" @click="clickSubmit"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getActivityDepartStaff,
  getActivityFuSearch,
} from "@/api/activeCode/activeCode.js";
export default {
  name: "CusChatSupervise",
  props: ["dialogVisibleTree", "currentSelectMember", "codeType", "title"],
  data() {
    return {
      show: false,
      formInline: {
        usageScenario: "",
      },
      treeData: [], //树-数据
      treeLength: 0, //树的全部数量
      defaultShowNodes: [1], //树形默认展开节点编号
      defaultCheckedKeys: [],
      currentNodeKey: "",
      defaultProps: {
        id: "id",
        children: "children",
        label: "departmentName",
      },
      currentMember: [], //已选成员 原始数据
      currentIdName: [], //已选成员名字 右侧显示
      serarchState: true, //搜索--成员弹窗,false搜索打开
      searchStaff: [], //成员--列表
      searchDepart: [], //部门--列表
      currentKeys: [], //当前树选中的节点
      staffList: [], //成员列表---有id
      departList: [], //部门列表---有id
      oldKeys: [], //当前树--选中的ID集合
    };
  },
  created() {
    getActivityDepartStaff(localStorage.getItem("Authorization"))
      .then((res) => {
        if (res.error.code == 200) {
          this.staffList = res.data.staff;
          this.departList = res.data.depart;
          this.treeData = res.data.departAndStaff;
        }
      })
      .catch((err) => {});
  },
  watch: {
    dialogVisibleTree(val) {
      this.show = val;
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.codeTree) {
            this.currentMember = this.currentSelectMember;
            this.$refs.codeTree.setCheckedNodes(this.currentSelectMember);

            if (this.currentSelectMember.length != 0) {
              //整理右侧列表数据
              this.getRightData(this.currentSelectMember);
            } else {
              this.currentIdName = [];
            }
            this.defaultShowNodes = [1];
          }
        });
      }
    },
    currentIdName() {
      this.$nextTick(() => {
        var container = this.$el.querySelector("#selectedWrap");
        container.scrollTop = 0;
      });
    },
  },
  methods: {
    // 选中搜索的结果
    clickSearchSelect(index, data) {
      let userId = data.userId != null ? data.userId : data.departmentId;
      if (this.currentIdName.length != 0) {
        let isSaveArr = this.currentIdName.filter((v) => {
          return v.id == userId;
        });
        if (isSaveArr.length == 0) {
          //未选中
          this.clickSearch(data);
          this.$nextTick(() => {
            setTimeout(() => {
              let firstId = !!data.userId ? data.userId : data.departmentId;
              let obj = {};
              this.currentIdName.forEach((item, index) => {
                if (item.id == firstId) {
                  obj = item;
                  this.currentIdName.splice(index, 1);
                  return;
                }
              });
              this.currentIdName.unshift(obj);
            }, 5);
          });
        } else {
        }
      } else {
        //选中
        this.clickSearch(data);
      }
      this.getSelectedData();
      this.serarchState = true;
      this.formInline.usageScenario = "";
    },
    //点击搜索的结果 同步数据
    clickSearch(clickData) {
      let data = clickData;
      if (data.userId != null) {
        let targetArr = this.staffList.filter((v) => {
          return v.userId == data.userId;
        });
        targetArr.map((v) => {
          this.$refs.codeTree.setChecked(v.id, true, true);
        });
      } else {
        let targetArr = [];
        for (let i = 0; i < this.departList.length; i++) {
          if (data.departmentId == this.departList[i].departmentId) {
            targetArr.push(this.departList[i]);
            break;
          }
        }
        this.$refs.codeTree.setChecked(targetArr[0].id, true, true);
      }
    },
    // 搜索
    searchFn() {
      if (this.formInline.usageScenario === "") {
        this.serarchState = true;
        this.currentMember.length != 0
          ? this.$refs.codeTree.setCheckedNodes(this.currentMember)
          : "";
        return;
      }
      this.serarchState = false;
      this.searchStaff = [];
      this.searchDepart = [];
      getActivityFuSearch(
        { search: this.formInline.usageScenario },
        localStorage.getItem("Authorization")
      )
        .then((res) => {
          this.searchStaff = res.data.staff;
          this.searchDepart = res.data.depart;
        })
        .catch((err) => {});
    },
    //清空搜索
    searchFnClear() {
      this.serarchState = true;
      this.currentMember.length != 0
        ? this.$refs.codeTree.setCheckedNodes(this.currentMember)
        : "";
    },
    //获取右侧列表的数据
    getRightData(data) {
      this.currentIdName = [];
      let memberList = data;
      memberList.map((v) => {
        this.currentIdName.push({
          treeId: v.id, //树id
          id: v.userId ? v.userId : v.departmentId,
          name: v.userName ? v.userName : v.departmentName,
          type: v.userId ? "per" : "depart",
        });
      });
      this.currentIdName = this.getArrSet(this.currentIdName, "id");
    },
    //获取选中的数据 点击树
    getSelectedData() {
      //选中的节点数据
      let checkedNodes = this.$refs.codeTree.getCheckedNodes();
      this.currentMember = checkedNodes;
      //整理右侧列表数据
      this.getRightData(this.currentMember);
    },
    //选择事件
    checkHandle(currentNode, data) {
      this.currentMember = data.checkedNodes;
      //整理右侧列表数据
      this.getRightData(this.currentMember);
    },
    //对象数组去重(根据userId去重)
    getArrSet(Arr, id) {
      var obj = {};
      const arrays = Arr.reduce((setArr, item) => {
        obj[item[id]] ? "" : (obj[item[id]] = true && setArr.push(item));
        return setArr;
      }, []);
      return arrays;
    },
    // 树点击选中
    nodeClick(data, node, s) {
      if (!!node) {
        //如果选择的是具体人员
        if (data.userId != null) {
          //获取同名的叶子节点
          let otherTargetArr = this.staffList.filter((v) => {
            return v.userId == data.userId;
          });
          if (otherTargetArr.length != 0) {
            otherTargetArr.map((v) => {
              this.$refs.codeTree.setChecked(v.id, true, true);
            });
          }
        }
        this.$nextTick(() => {
          setTimeout(() => {
            let firstId = !!data.userId ? data.userId : data.departmentId;
            let obj = {};
            this.currentIdName.forEach((item, index) => {
              if (item.id == firstId) {
                obj = item;
                this.currentIdName.splice(index, 1);
                return;
              }
            });
            this.currentIdName.unshift(obj);
          }, 5);
        });
      } else {
        if (data.userId != null) {
          //获取同名的叶子节点
          let otherTargetArr = this.staffList.filter((v) => {
            return v.userId == data.userId;
          });
          if (otherTargetArr.length != 0) {
            otherTargetArr.map((v) => {
              this.$refs.codeTree.setChecked(v.id, false, true);
            });
          }
        }
      }
    },
    // 点击删除
    clickCurrrntFn(item) {
      //删除部门
      this.currentIdName = this.currentIdName.filter((v) => {
        return v.id != item.id;
      });
      this.currentMember = this.currentMember.filter((v) => {
        return v.departmentId != item.id && v.userId != item.id;
      });
      if (item.type == "depart") {
        this.$refs.codeTree.setChecked(item.treeId, false, true);
      } else {
        //删除员工
        //获取同userId的叶子节点
        let otherTargetArr = this.staffList.filter((v) => {
          return v.userId == item.id;
        });
        otherTargetArr.map((v) => {
          this.$refs.codeTree.setChecked(v.id, false, true);
        });
      }
    },
    //收缩展开树
    clickClose() {
      // 2022/5/12 修改
      // this.currentMember = [];
      // this.$refs.codeTree.setCheckedNodes(this.currentMember);
      // for (var i = 0; i < this.$refs.codeTree.store._getAllNodes().length; i++) {
      //   this.$refs.codeTree.store._getAllNodes()[i].expanded = false;
      // }
    },
    closeTree() {
      this.clickClose();
      this.$emit("closeTree", false);
    },
    // 确定-添加-使用人员
    clickSubmit() {
      if (this.codeType != undefined) {
        switch (this.codeType) {
          case "1": //1:批量单人
            this.$emit("clickSubmitTree", this.currentMember);
            this.clickClose();
            break;
          case "0": //0:单人
            if (this.currentIdName.length > 1) {
              this.$message.warning("单人活码类型仅可选择单个员工");
            } else if (this.currentIdName.length == 1) {
              if (this.currentIdName[0].type == "depart") {
                this.$message.warning("单人活码类型仅可选择单个员工");
              } else {
                this.$emit("clickSubmitTree", this.currentMember);
                this.clickClose();
              }
            } else {
              this.$emit("clickSubmitTree", this.currentMember);
              this.clickClose();
            }
            break;
          default:
            break;
        }
      } else {
        this.$emit("clickSubmitTree", this.currentMember);
        this.clickClose();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.addMember {
  /deep/.el-dialog__body {
    padding-top: 10px;
  }
  .head-wrap {
    align-items: center;
    display: flex;
    .head-left {
      flex: 1;
      .search-input {
        width: 100%;
      }
    }
    .head-right {
      flex: 1;
      text-align: left;
      .selected-title {
        font-weight: 600;
        font-size: 16px;
        padding-left: 20px;
      }
    }
  }
  .data-wrap {
    display: flex;
    margin-top: 10px;
    .tree-wrap {
      flex: 1;
      min-height: 350px;
      max-height: 450px;
      overflow: auto;
      border-right: 1px solid rgb(196, 196, 196);
      .el-tree {
        padding-right: 10px;
        /deep/.el-tree-node__content {
          position: relative;
          .el-checkbox__inner {
            background: none;
            border: none;
          }
          .el-checkbox__inner::after {
            border-right: 2px solid rgb(83, 83, 83);
            border-bottom: 2px solid rgb(83, 83, 83);
          }
        }
        /deep/.el-checkbox {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .selected-wrap {
      flex: 1;
      min-height: 350px;
      max-height: 450px;
      overflow: auto;
      .select-right {
        display: flex;
        justify-content: space-between;
        padding: 6px 5px;
        margin-left: 15px;
        font-size: 15px;
        font-weight: bold;
        &:hover {
          background-color: #f0f7ff;
        }
        .el-icon-close {
          font-size: 15px;
          cursor: pointer;
          &:hover {
            background: #95c7ff;
            border-radius: 50%;
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }

    .welcomeDia {
      .el-dialog__body {
        min-height: 200px;
        margin: 20px 20px;
        padding: 0px !important;
      }
      /deep/.el-dialog__footer {
        text-align: right;
      }
    }
    .treeDia {
      .el-dialog__body {
        min-height: 400px;
      }
    }
    .custom-tree-node {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .ww_searchResult {
    .search-title {
      font-size: 16px;
      font-weight: bold;
    }
    .search-data-wrap {
      margin-top: 6px;
      padding: 0 8px 0 0;
    }
  }
  .ww_searchResult_itemTxt {
    text-decoration: none;
    overflow: hidden;
    zoom: 1;
    color: #000000;
  }
  .ww_searchResult_title_peopleName {
    width: 50%;
    float: left;
    padding-right: 7px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ww_searchResult_title_peopleDepartment {
    overflow: hidden;
    zoom: 1;
    display: block;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .ww_searchResult li {
    &:hover {
      background: #ccc;
    }
  }
  .ww_searchResult li {
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    padding-left: 0px;
    white-space: nowrap;
    overflow: hidden;
    padding-left: 5px;
  }
}
</style>
